import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type WorkstreamResponseType = ResponseType<{
  message: string;
  workstreamId: string;
  workstreamName: string;
}>;

export function useCreateWorkstreamMutation() {
  return useMutation<
    AxiosResponseAndError<WorkstreamResponseType>["response"],
    AxiosResponseAndError<WorkstreamResponseType>["error"],
    { workstreamName: string }
  >({
    mutationFn: (data) =>
      ApiRequest.post<WorkstreamResponseType>(
        `${requestURLs.project}/workstream`,
        data
      ),
  });
}

export function useUpdateWorkstreamMutation() {
  return useMutation<
    AxiosResponseAndError<WorkstreamResponseType>["response"],
    AxiosResponseAndError<WorkstreamResponseType>["error"],
    { workstreamId: string; workstreamName: string }
  >({
    mutationFn: ({ workstreamId, workstreamName }) =>
      ApiRequest.put<WorkstreamResponseType>(
        `${requestURLs.project}/workstream/${workstreamId}`,
        { workstreamName }
      ),
  });
}

export function useRemoveWorkstreamMutation() {
  return useMutation<
    AxiosResponseAndError<ResponseType<null>>["response"],
    AxiosResponseAndError<ResponseType<null>>["error"],
    string
  >({
    mutationFn: (workstreamId) =>
      ApiRequest.delete<ResponseType<null>>(
        `${requestURLs.project}/workstream/${workstreamId}`
      ),
  });
}
